'use client';

import React, { useState, useEffect } from 'react';
import { db, storage } from '../../../firebaseConfig';
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  Timestamp,
} from 'firebase/firestore';
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';
import { getAuth } from 'firebase/auth';

export default function AdminGallery() {
  const [imageFile, setImageFile] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);

  // ✅ Check if user is authenticated
  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      console.log('🔒 Authenticated user:', user.email || user.uid);
    } else {
      console.warn('❌ No user authenticated. Uploads will fail.');
    }
  }, []);

  useEffect(() => {
    const fetchImages = async () => {
      const querySnapshot = await getDocs(collection(db, 'gallery'));
      const images = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setGalleryImages(images);
    };
    fetchImages();
  }, []);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!imageFile) return alert('Please select an image first.');

    try {
      const auth = getAuth();
      if (!auth.currentUser) {
        alert('You must be logged in to upload.');
        return;
      }

      const storageRef = ref(storage, `gallery/${Date.now()}-${imageFile.name}`);
      await uploadBytes(storageRef, imageFile);
      const downloadUrl = await getDownloadURL(storageRef);

      const docRef = await addDoc(collection(db, 'gallery'), {
        imageUrl: downloadUrl,
        uploadedAt: Timestamp.now(),
      });

      setGalleryImages([...galleryImages, { id: docRef.id, imageUrl: downloadUrl }]);
      setImageFile(null);
      alert('Image uploaded successfully!');
    } catch (err) {
      console.error('Upload failed:', err);
      alert('Image upload failed');
    }
  };

  const handleDelete = async (id, imageUrl) => {
    try {
      const auth = getAuth();
      if (!auth.currentUser) {
        alert('You must be logged in to delete.');
        return;
      }

      const imageRef = ref(storage, imageUrl);
      await deleteObject(imageRef);
      await deleteDoc(doc(db, 'gallery', id));
      setGalleryImages(galleryImages.filter((img) => img.id !== id));
      alert('Image deleted');
    } catch (err) {
      console.error('Delete failed:', err);
      alert('Failed to delete image');
    }
  };

  return (
    <div className="container py-4">
      <h2 className="text-center mb-4">Upload New Gallery Image</h2>
      <form onSubmit={handleUpload} className="mb-5">
        <input
          type="file"
          accept="image/*"
          className="form-control mb-3"
          onChange={(e) => setImageFile(e.target.files[0])}
        />
        <button type="submit" className="btn btn-primary">Upload</button>
      </form>

      <div className="row g-4">
        {galleryImages.map((item) => (
          <div key={item.id} className="col-md-4">
            <div className="card">
              <img
                src={item.imageUrl}
                alt="Gallery item"
                className="card-img-top"
                style={{ height: 200, objectFit: 'cover' }}
              />
              <div className="card-footer text-center">
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(item.id, item.imageUrl)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
